export const APP_SESSION_STATE_TITLE_KEY = 'mildang-app-session-title';
